module.exports = __webpack_public_path__ + "media/leadPages/footer-img-06c06228.png";